/**
 * Texts for Careers page
 */
export const careersPageText = {
    title: 'Careers',
    titleMeta: 'Careers — Job vacancies | CamDiab',
    descriptionMeta: 'Explore career opportunities at CamDiab. Join our team working to improve life for people living with diabetes.',
    keywords: 'CamDiab careers, jobs, vacancies, diabetes technology',
    localeMeta: 'en_ca',

    bannerTitle: 'Job vacancies',
    bannerSubtitle: 'Interested in joining our team?',
    heroNote: 'All job postings are published in English.',

    introBody:
        'If you are looking for a new challenge and would like to help shape meaningful change, we’d love to hear from you. We invest in our people who are the beating heart of CamDiab. Our employee benefits are designed to bring the best out of everyone and include:',

    benefitsTitle: '',
    benefits: [
        'Generous Employer Pension contribution',
        'Private Medical Insurance',
        'Life Assurance',
        'Annual discretionary bonus',
        '29 days annual leave plus 8 days Bank Holidays',
        'Opportunity to work on groundbreaking technology that has the potential to transform diabetes management and improve patient outcomes',
        'Collaborative and dynamic work environment',
        'Competitive salary and benefits package, including opportunities for professional development and career advancement',
    ],

    outroHtml:
        'If you’re passionate about making real-world impact, we’d love to hear from you:<a href="mailto:hr@camdiab.com" class="careers-email-link">hr@camdiab.com</a>',

    vacancies: [
        {
            id: 'qra-1',
            title: 'Quality and regulatory associate',
            description:
                'You’ll be supporting the continuous improvement of our Quality Management System (QMS) and regulatory activities. You’ll play a key role in day-to-day quality processes, document control, and cross-functional collaboration in a highly regulated, fast-paced environment.',
            meta: ['Hybrid working', 'Full-time/Part-time', '£30–36K p/a'],
            applyUrl: 'https://camdiab.com/careers',
        },
    ],

    emptyVacancyTitle: 'No current vacancies',
    emptyVacancyBody:
        'We may not be hiring at the moment, but CamDiab is growing, and we are always interested in hearing from people who are passionate about making life better for those living with diabetes. Please check back here for future opportunities.',

    applyLabel: 'Apply now',
};
